<div [class.mt-3]="!props.collapseMargin">
  <div class="row">
    @if (props.hideLabel !== true) {
      <label class="col fw-bold d-block">
        @if (showMandatoryIndicator) {
          <span class="text-colour-red-600">
            *
          </span>
        }
        {{ props.label }}
        @if (props.lockedNote) {
          <span class="field-locked-note ms-1 small">{{ props.lockedNote }}</span>
        }
      </label>
    }

    @if (props.helpText) {
      <small class="form-text text-muted mb-2">
        {{ props.helpText }}
      </small>
    }
    
    @if (props.tooltip) {
      <i
        class="col-1 far fa-question-circle my-auto"
        (click)="openTooltip()"
      ></i>
    }
  </div>

  <ng-container #fieldComponent />

  @if (showError && !props.suppressErrors && showGroupField) {
    <div class="d-flex gap-3 align-items-center mt-2 alert alert-danger is-invalid">
      <i class="fas fa-times-circle"></i>
      <span>
        <formly-validation-message [field]="field" />
      </span>
    </div>
  }
</div>
